import {
	Injectable
} from '@angular/core';
import { AudioPage } from 'src/app/presenters/user-cases/audio-page/audio-page';
import { PowerPage } from '../../../presenters/user-cases/power-page/power-page';
import { DeviceSettings } from 'src/app/presenters/user-cases/device-settings/device-settings';
import { EDeviceSettingsPages } from 'src/app/enums/device-settings-page.enum';
import { InputAccessoriesPage } from 'src/app/presenters/user-cases/input-accessories/input-accessories-page';

@Injectable({
	providedIn: 'root'
})
export class DeviceSettingsConfigService {

	constructor(
		private audioPage: AudioPage,
		private powerPage: PowerPage,
		private inputAccessoriesPage: InputAccessoriesPage,
		private deviceSettings: DeviceSettings
	) { }

	public async getLaptopMenuItemsAvailabilities() {
		return [
			{
				id: EDeviceSettingsPages.Audio,
				visibility: await this.audioPage.isVisible(),
			},
			{
				id: EDeviceSettingsPages.Power,
				visibility: await this.powerPage.isVisible(),
			},
			{
				id: EDeviceSettingsPages.InputAndAccessories,
				visibility: await this.inputAccessoriesPage.isVisible(),
			}
		]
	}

	public async getDesktopMenuItemVisibility() {
		return await this.deviceSettings.isVisible();
	}
}
